module.exports = __webpack_public_path__ + "img/file-easel.853dc1ff.svg";